/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nice_Factual_Hornet_EmpowerInputs */

const fr_nice_factual_hornet_empower = /** @type {(inputs: Nice_Factual_Hornet_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter PR`)
};

/**

* @param {Nice_Factual_Hornet_EmpowerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const nice_factual_hornet_empower = /** @type {((inputs?: Nice_Factual_Hornet_EmpowerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nice_Factual_Hornet_EmpowerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_nice_factual_hornet_empower(inputs)
});